import { Component, OnInit, Optional } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { UserStoreService } from 'src/app/core/services/user-store.service';
import { Notificaciones } from 'src/app/notificaciones';

@Component({
  selector: 'app-restaurar-password',
  templateUrl: './restaurar-password.component.html',
  styleUrls: ['./restaurar-password.component.scss']
})
export class RestaurarPasswordComponent {

  mailForm: FormControl = new FormControl(null, Validators.compose([Validators.required, Validators.email]));

  constructor(
    @Optional() private dialogRef: MatDialogRef<RestaurarPasswordComponent>,
    private userStoreService: UserStoreService,
    private router: Router,
    private notificaciones: Notificaciones) {
  }

  sendMail() {
    this.notificaciones.carga('Enviando correo para recuperación de contraseña');
    this.userStoreService.forgotPass({
      email: this.mailForm.value
    }).subscribe({
      error: () => this.notificaciones.error('Ha ocurrido un error, vuelve a intentarlo más tarde'),
      complete: () =>
        this.notificaciones.exito(
          'El correo con las instrucciones ha sido enviado'
        ).then(() => {
          this.dialogRef.close();
          this.router.navigate(['/']);
        })
    });
  }

}
